<template>
  <v-dialog v-model="dialog" persistent max-width="1000px">
    <v-card :loading="loading">
      <v-card-title>
        <span class="text-h5">Elenco Magazzini</span>
        <v-spacer></v-spacer>
        <span><v-btn color="primary" dark class="" @click="onNuovoMagazzino">Nuovo Magazzino</v-btn></span>
      </v-card-title>
      <v-card-text>
        <v-container fluid dense>
          <v-row dense>        
            <v-col dense cols="12">
              <v-data-table :headers="headerMagazzini" :items="magazzini" dense disable-sort :items-per-page="10">
                <template v-slot:[`item.codice`]="{ item }">
                  <v-text-field v-model="item.codice" placeholder="Codice" hide-details flat @change="saveEnable = true"></v-text-field>
                </template>                
                <template v-slot:[`item.descrizione`]="{ item }">
                  <v-text-field v-model="item.descrizione" placeholder="Descrizione" hide-details flat @change="saveEnable = true"></v-text-field>
                </template>
                <template v-slot:[`item.default`]="{ item }">
                  <v-switch dense class="ml-2" inset v-model="item.default" hide-details @change="onChangeDefault"></v-switch>                  
                </template>
                <template v-slot:[`item.temporaneo`]="{ item }">
                  <v-switch dense class="ml-2" inset v-model="item.temporaneo" hide-details @change="onChangeTemporaneo"></v-switch>   
                </template>                
                <template v-slot:[`item.attivo`]="{ item }">
                  <v-switch dense class="ml-2" inset v-model="item.attivo" hide-details @change="onChangeAttivo"></v-switch>   
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="onSalvaMagazzini" :disabled="!saveEnable">Salva</v-btn>
        <v-btn color="blue darken-1" text @click.stop="dialog = false">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn  color="blue" text v-bind="attrs" @click="snackbar = false">
          OK
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>  
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService'
  export default {
    components: {

    },
    props: {
      show: Boolean
    },
    data () {
      return {
        magazzini: [],
        confMagazzini: null,
        attuale: [],
        dialog: false,
        loading: false,
        headerMagazzini: [
          { text: 'CODICE', value: 'codice', align: 'start', width: "15%" },
          { text: 'DESCRIZIONE', value: 'descrizione', align: 'start', width: "55%" },
          { text: 'DEFAULT', value: 'default', align: 'start' },
          { text: 'TEMPORANEO', value: 'temporaneo', align: 'start' },
          { text: 'ATTIVO', value: 'attivo', align: 'start' }
        ],
        numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
        snackbar: false,
        snackColor: '',
        snackText: '',
        timeout: 4000,
        saveEnable: false
      }
    },
    async mounted() {
      this.confMagazzini = await configurazioni.getConfigurazione('magazzino_magazzini')
      this.magazzini = this.confMagazzini.magazzini
    },
    watch: {
      async show(value) {
        if (value) {
          this.dialog = true
          await this.elaboraTabelle()
        }
      }
    },
    methods: {
      onNuovoMagazzino() {
        const mag = {
          codice: '',
          descrizione: '',
          default: false,
          temporaneo: false,
          attivo: true
        }
        this.magazzini.push(mag)
      },
      async onChangeDefault(item) {
        await this.aggiornaMagazzino(item)
      },
      async onChangeTemporaneo(item) {
        await this.aggiornaMagazzino(item)
      },
      async onChangeAttivo(item) {
        await this.aggiornaMagazzino(item)
      },
/*       async onSaveAcquisto(item) {
        const valore = isNaN(item.acquisto) ? '' : +parseFloat(item.acquisto).toFixed(2)
        await this.aggiornaPrezzo(item, valore, 'acquisto')
      },
      async onSavePrezzo(item) {
        const valore = isNaN(item.prezzo) ? '' : +parseFloat(item.prezzo).toFixed(2)
        await this.aggiornaPrezzo(item, valore)
      },
      async onSaveRicarico(item) {
        let valore = ''
        if (!isNaN(item.ricarico)) {
          const ricarico = +parseFloat((item.ricarico) / 100).toFixed(2)
          valore = item.acquisto * (ricarico + 1)
        }
        await this.aggiornaPrezzo(item, valore)
      }, */
/*       async onSaveSconto(item) {
        // TODO: Completare
        const valore = isNaN(item.sconto) ? '' : +parseFloat(item.sconto).toFixed(2)
        // await this.aggiornaPrezzo(item, valore)
      }, */
      async aggiornaMagazzino(item) {
        this.saveEnable = true
        // const idProdotto = _.get(this.prodotto,'appoggio.prodotto.id', _.get(this.prodotto, 'prodotto.codice', ''))
        // const valore = isNaN(item.prezzo) ? '' : +parseFloat(item.prezzo).toFixed(2)
/*         if (!idProdotto || ! valore) {
          this.snackColor = 'red accent-2'
          this.snackText = 'Il valore non è valido'
          this.snackbar = true
          return
        } */
        // considero sempre codiceListino perchè la chiave è completa anche se cliente (es _L_codicexxx, _LT_tipoyyyy) o tipoCliente
        // await prodotti.aggiornaPrezzo(tipoPrezzo, idProdotto, item.codiceListino, valore)
        // await this.elaboraMagazzini()

      },
      async elaboraTabelle() {
        this.loading = true
        await this.elaboraMagazzini()
        this.loading = false
      },
      async elaboraMagazzini() {

      },
      async onSalvaMagazzini() {
        await configurazioni.modificaConfigurazione(this.confMagazzini)
        this.$emit('change')
        this.snackColor = 'success'
        this.snackText = 'Salvataggio effettuato con successo'
        this.snackbar = true
        this.saveEnable = false
      }

/*       async elaboraMagazzini() {
         if (!this.prodotto) return
        var r = this.prodotto 
        const magazzini = this.magazzini
        const prodotto = await prodotti.getProdotto(r.prodotto.codice)
        const acquisto = _.get(prodotto, 'magazzino.prezzoAcquisto', 0)
        const pp = prodotto.prezzo
        const prezzi = []

        for (let magazzino of magazzini) { // elenco magazzini
          let pz = pp[listino.codice]
          if (pz) {
            const base = pz.base ? +parseFloat(pz.base).toFixed(2) : 0
            let ricarico = acquisto > 0 && pz.base ? +(((base - acquisto) / acquisto) * 100).toFixed(2) : '---'
            const iva = _.get(r, 'aliquotaIva.valore', 22)
            // Dovrei mostrare entrambi i prezzi, ma diventa un problema per quale è modificabile, perchè cambia in base al listino
            let netto = listino.ivato ? base / (1 + iva / 100) : base
            let lordo = listino.ivato ? base : base * (1 + iva / 100)
            if (listino.ivato) {
              // const iva = _.get(r, 'aliquotaIva.valore', 22)
              let prz = base / (1 + iva / 100)
              ricarico = acquisto > 0 && pz.base ? +(((prz - acquisto) / acquisto) * 100).toFixed(2) : '---'
            }
            const ivato = listino.ivato ? '* ' : ''
            const prezzo = {
              codiceListino: listino.codice,
              listino: ivato + (listino.descrizione || listino.codice),
              prezzo: pz.base ? base : '',
              ricarico: ricarico,
              acquisto
            }
            prezzi.push(prezzo)
          } else {
            const prezzo = {
              codiceListino: listino.codice,
              listino: listino.descrizione || listino.codice,
              // prezzoNetto: '',              
              prezzo: '',
              ricarico: '',
              acquisto
            }
            prezzi.push(prezzo)
          }
        }

        const elencoPrezzi = Object.keys(pp)
        for (let p of elencoPrezzi.filter(x => !magazzini.map(l => l.codice).includes(x))) {  // elenco prezzi speciali (no magazzini)
          let pz = pp[p]
          if (pz) {
            const listino = this.magazzini.find(x => x.codice === p)
            const ricarico = acquisto > 0 ? +(((pz.base - acquisto) / acquisto) * 100).toFixed(2) : '---'
            const prezzo = {
              codiceListino: p,
              listino: listino ? listino.descrizione : p,
              prezzo: +pz.base.toFixed(2),
              ricarico: ricarico,
              acquisto
            }
            prezzi.push(prezzo)
          }
        }
        // elenco prezzi specifici per il cliente selezionato (deve verificare di non averli già riportati sopra)
        const listinoCliente = `_L_${this.cliente.codice}`
        if (!elencoPrezzi.find(x => x === listinoCliente)) {
            const prezzo = {
              codiceListino: listinoCliente,
              listino: listinoCliente,
              prezzo: '',
              ricarico: '',
              acquisto
            }
            prezzi.push(prezzo)
        }
        const tipologiaCliente = _.get(this.cliente, 'amministrativi.tipologiaCliente.codice','')
        if (tipologiaCliente.length > 0) {
          const listinoTipologia = `_LT_${tipologiaCliente}`
          if (!elencoPrezzi.find(x => x === listinoTipologia)) {
              const prezzo = {
                codiceListino: listinoTipologia,
                listino: listinoTipologia,
                prezzo: '',
                ricarico: '',
                acquisto
              }
              prezzi.push(prezzo)
          }
        }
        this.prezzi = prezzi
      }  */
    }
  }
</script>

<style lang="scss" scoped>
  .v-input--selection-controls {
    margin-top: 8px;
    margin-bottom: 8px;
    padding-top: 2px;
    padding-bottom: 2px;
  }
</style>